import { Select } from "antd";

const FilterSelect = ({ 
  mode = "multiple",
  value, 
  options, 
  onChange, 
  placeholder,
  style = { width: '80%' },
  maxTagCount = 0,
  allowClear = true,
  className = "mt-2"
}) => {
  const handleChange = (selectedValues) => {
    if (selectedValues?.includes('all')) {
      onChange(options.slice(1).map(option => option.value));
    } else {
      onChange(selectedValues);
    }
  };

  return (
    <Select
      className={className}
      mode={mode}
      allowClear={allowClear}
      style={style}
      options={options}
      onChange={handleChange}
      maxTagCount={maxTagCount}
      placeholder={placeholder}
      value={value}
    />
  );
};

export default FilterSelect;
